class Chatbot {
  constructor(res = { active: false, chatbotServiceCenter: {}, timeOver: false }) {
    const {
      active,
      chatbotServiceCenter,
      timeOver
    } = res

    this.active = active
    this.timeOver = timeOver

    if (chatbotServiceCenter) {
      this.serviceCenter = {
        startDate: chatbotServiceCenter.operationStartDateTime,
        endDate: chatbotServiceCenter.operationEndDateTime,
        active: chatbotServiceCenter.active
      }
    } else {
      this.serviceCenter = null
    }
  }

  closedPopupMessage() {
    if (!this.serviceCenter) return ''

    const getMeridiemTime = (hour) => {
      if (hour >= 12)
        return '오후'
      else if (hour >= 6)
        return '오전'
      
      return '새벽'
    }

    // const startDate = this.startDate.split(' ')[0].split('-')
    const startTime = this.serviceCenter.startDate.split('T')[1].split(':')
    const endTime = this.serviceCenter.endDate.split('T')[1].split(':')

    let hour = parseInt(startTime[0], 10)

    const startMeridiemText = getMeridiemTime(hour)
    const startHourText = hour >= 12 ? hour - 12 : hour

    hour = parseInt(endTime[0], 10)
    const endMeridiemText = getMeridiemTime(hour)
    const endHourText = hour >= 12 ? hour - 12 : hour

    return `채팅상담은 ${startMeridiemText} ${startHourText}시부터 익일 ${endMeridiemText} ${endHourText}시까지만 가능합니다. 고객센터로 전화해주세요`
  }

  isOperating() {
    return this.serviceCenter && !this.timeOver
  }

  isServiceArea() {
    return this.active
  }

  isClosedCenter() {
    return this.serviceCenter.active === false
  }
}

export default Chatbot

export const ofChatbot = (param) => new Chatbot(param)
